import { cssVariableStyles, constants } from "@newsela/angelou";

const { ui } = constants.colors;
const { generateIconColorCss } = cssVariableStyles;

export const buttonIconCss = {
  Icon: {
    root: {
      width: 17,
      ...generateIconColorCss({
        primaryColor: ui.neutral[600],
      }),
      path: {
        strokeWidth: 2,
      },
    },
  },
};

export const dialogCss = {
  Button: {
    Icon: {
      root: {
        width: 15,
      },
    },
  },
};
